<script setup lang="ts">
import BannerCarousel from './BannerCarousel.vue';
import LandingBanner from './LandingBanner.vue';

const contentStore = useContentStore();
const route = useRoute();
const {
    homepageFilteredBanners,
    homepageFilteredSliders,
    homepageMessagesLoading,
} = classToRefs(contentStore);
const { isMobile } = useSize();
const show = computed(
    () =>
        banners.value.length > 0 ||
        sliders.value.length > 0 ||
        homepageMessagesLoading.value
);
const banners = computed(() =>
    homepageFilteredBanners.value
        .filter(
            m =>
                !m.displaySize ||
                m.displaySize === 'both' ||
                (m.displaySize === 'mobile' ? isMobile.value : !isMobile.value)
        )
        .filter(m => new RegExp(m.urlPattern || '').test(route.path))
);
const sliders = computed(() =>
    homepageFilteredSliders.value
        .map(sliders =>
            sliders
                .filter(
                    m =>
                        !m.displaySize ||
                        m.displaySize === 'both' ||
                        (m.displaySize === 'mobile'
                            ? isMobile.value
                            : !isMobile.value)
                )
                .filter(m => new RegExp(m.urlPattern || '').test(route.path))
        )
        .filter(sliders => sliders.length)
);
</script>

<template>
    <div v-if="show" class="landing-banners-wrapper">
        <div class="landing-banners-container">
            <BannerCarousel
                v-for="(slider, sliderIndex) in sliders"
                :key="`slider-${sliderIndex}`"
                :items="slider"
            />
            <LandingBanner
                v-for="banner in banners"
                :id="`banner-click-${banner.id}`"
                :key="banner.id"
                :banner
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.landing-banners-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    padding-top: 0;
    padding-bottom: 20px;
}

.landing-banners-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: $app-container-max-width;
}

@media (max-width: ($app-container-max-width + 32px)) {
    .landing-banners-wrapper {
        padding-right: 16px;
        padding-left: 16px;
    }
}
</style>
